import { DeviceGpsType } from '../types/device';

export const DEVICE_GPS_TYPE_TRACKING = 'Rastreo';
export const DEVICE_GPS_TYPE_OBD = 'OBD';
export const DEVICE_GPS_TYPE_CAMERA = 'Cámara';

export const GPS_TYPE_LABELS = {
  [DeviceGpsType.tracking]: DEVICE_GPS_TYPE_TRACKING,
  [DeviceGpsType.obd]: DEVICE_GPS_TYPE_OBD,
  [DeviceGpsType.camera]: DEVICE_GPS_TYPE_CAMERA,
};
